export const roundPrice = (value: number) => Math.round(value * 100) / 100;

export const calcPercent = (min, max, value) => {
  return ((value - min) / (max - min)) * 100;
};

export const clamp = (min, max, value) => {
  return Math.min(Math.max(min, value), max);
}